import Dialog from 'components/dialog/dialog';
import { useUserProfileQuery } from '../../api/user.api';
import { TwoVerfiyForm } from '../forms/two-verify.form';

const TwoVeifyDialog = ({ open, onClose }: any) => {
    const { data: profile } = useUserProfileQuery();
    const isActive = !!profile?.twoverify;

    return (
        <Dialog
            label={
                isActive
                    ? 'غیرفعال‌سازی تایید دومرحله‌ای'
                    : 'فعال‌سازی تایید دومرحله‌ای'
            }
            open={open}
            onClose={onClose}
            icon={<i className="fa-light fa-shield-halved" />}
            type={isActive ? 'error' : 'success'}
        >
            {open ? <TwoVerfiyForm key={isActive ? 'disable' : 'enable'} onClose={onClose} /> : null}
        </Dialog>
    );
};

export default TwoVeifyDialog;
